import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, HostListener, QueryList, ViewChildren } from '@angular/core';
import { Encuesta, Muro } from '../../comun/models/muro.model';
import { ImagePopupService } from '../../comun/services/image-popup.service';
import { QueryService } from '../../comun/services/query.service';
import { LoaderService } from '../../comun/services/loader.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GeoService } from '../../comun/services/geo.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import { GlobalConstants } from '../../global-constants';
import { forkJoin } from 'rxjs';
import { MuroService } from '../../comun/services/muro.service';
import Swal from 'sweetalert2';
import { Valores } from '../../comun/models/valores.model';
import { MuroFiltrosService } from '../../comun/services/muro-filtros.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-muro-acciones',
  templateUrl: './muro-acciones.component.html',
  styleUrl: './muro-acciones.component.css'
})
export class MuroAccionesComponent {
  @Output() abrirConversacion = new EventEmitter<void>();
  @Input() misdatos!: any;
  @Input() perfil!: any;
  @Input() muro!: Muro;
  @Input() tipo!: string;
  @Input() tipoId!: number;
  @ViewChildren('comentarTextarea') textareas!: QueryList<ElementRef<HTMLTextAreaElement>>;
  @ViewChild('publicarTextarea') publicarTextarea!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('fileInputRedSocial') fileInput!: ElementRef<HTMLInputElement>;
  participo: boolean = false;
  mascotas: any[] = [];
  tipopublicaciones: any[] = [];
  tiposervicios: any[] = [];
  tipoencuestas: any[] = [];
  global: any = GlobalConstants;
  mostrarPanel = false;
  albumAbierto = false;
  albumCargando = false;
  albumFotos: any[] = [];
  @HostListener('document:keydown.escape') cerrarAlbumEscape(): void { if (this.albumAbierto) this.cerrarAlbumPaseo(); }
  abrirAlbumPaseo(): void {
    this.albumAbierto = true;
    this.albumCargando = true;
    this.albumFotos = [];
    this.query.query('muros', 'ALBUM_PASEO', { rs_id: this.muro.rs_id }).subscribe({
      next: (r: any) => { this.albumFotos = r?.resultado === 'OK' && Array.isArray(r.registros) ? r.registros : []; this.albumCargando = false; },
      error: () => { this.albumCargando = false; }
    });
  }
  cerrarAlbumPaseo(): void { this.albumAbierto = false; }

  motivoSeleccionado = '';
  reporteAbierto = false;
  reporteDetalle = '';
  enviandoReporte = false;
  pregunta_encuesta: Encuesta = { rse_id: 0, rse_rs_id: 0, rse_pregunta: '', rse_tipo: '', rse_respuesta_1: '', rse_respuesta_2: '', rse_respuesta_3: '', rse_respuesta_4: '', va_nombre: '', rser_respuesta: '', rse_borrado: false, respuestas: null, totalVotos: 0, busy: false };

  constructor(public imagepopup: ImagePopupService, 
              private loader: LoaderService, 
              private query: QueryService,
              private funciones: FuncionesService,
              private http: HttpClient,
              private muroService: MuroService,
              private muroFiltrosService: MuroFiltrosService) { }

  ngOnInit() {
    this.getTipoPublicaciones();
    this.getTipoServicios();
    this.getTipoEncuestas();
    // Si el muro está en un paseo, comprobar si el usuario actual participa
    if (this.tipo == 'PA') {
      this.query.query('paseos', 'PARTICIPO', { pa_id: this.tipoId }).subscribe((resultado:any) => {
        this.participo = resultado;
      });
    } else {
      this.participo = true;
    }
  }

  ngAfterViewInit() {
    this.imagepopup.init();
    // Foco al textarea de comentar
    this.textareas.changes.subscribe(() => {
      const textarea = this.textareas.last;
      textarea?.nativeElement.focus();
    });
  }

  getTipoPublicaciones() {
    this.query.query('valores', 'GET', { grupo: 'PUBLICACION'}).subscribe((resultado:any) => {
      this.tipopublicaciones = resultado.registros;
    });
  }

  getTipoServicios() {
    this.query.query('valores', 'GET', { grupo: 'SERVICIO'}).subscribe((resultado:any) => {
      this.tiposervicios = resultado.registros;
    });
  }

  getTipoEncuestas() {
    this.query.query('valores', 'GET', { grupo: 'ENCUESTA'}).subscribe((resultado:any) => {
      this.tipoencuestas = resultado.registros;
    });
  }

  getMascotas(mascota: any = null) {
    this.query.query('mascotas', 'GET', null).subscribe((resultado:any) => {
      this.mascotas = resultado.registros;
    });
  }

  editarPublicacion(nueva: boolean = false, tipoPublicacion: string = '') {
    if (!nueva && Number(this.muro.rs_us_id) !== Number(this.misdatos?.ID)) return;
    this.getMascotas();
    this.muro.nuevo = nueva;
    if (nueva) {      
      this.muro.rs_id = 0;
      this.muro.rs_tipo = this.tipo;
      this.muro.rs_tipo_id = this.tipoId;
      this.muro.rs_tipo_publicacion = tipoPublicacion;
      this.muro.rs_texto = '';
    } else {
      this.muro.rs_texto = this.prepararTextoParaEditar(this.muro.rs_texto);
    }
    this.muro.imagenes = [];
    this.muro.previewUrl = [];
    this.muro.rs_fotos.forEach((foto: { foto_thumb: string, foto_grande: string, ft_id: number }) => {
      this.muro.imagenes.push({
        data: '',
        url: foto.foto_grande,
        borrada: false,
        ft_id: foto.ft_id
      });

      this.muro.previewUrl.push({
        data: '',
        url: foto.foto_thumb,
        borrada: false,
        ft_id: foto.ft_id
      });
    });
    this.muro.showeditar = true;
    // Espera a que Angular renderice el textarea
    setTimeout(() => {
      this.publicarTextarea?.nativeElement.focus();
      this.funciones.irAlMarcador('muro' + this.muro.rs_id);
    }, 0);
  }

  prepararTextoParaEditar(textoGuardado: string): string {
    if (!textoGuardado) {
      return '';
    }

    // 1. Quitar las etiquetas <a ...>...</a>, dejando solo el contenido (texto/URL del link)
    const textoSinLinks = textoGuardado.replace(/<a [^>]*>(.*?)<\/a>/gi, '$1');

    // 2. Decodificar entidades HTML (&amp;, &lt;, etc.)
    const textoPlano = this.decodificarEntidadesHtml(textoSinLinks);

    return textoPlano;
  }

  private decodificarEntidadesHtml(texto: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = texto;
    return textarea.value;
  }

  publicarPost() {
    if (!this.validarFormulario()) {
      return;
    }
    this.loader.show();
    this.muro = this.muroService.limpiarParent(this.muro);
    this.query.query('muros', 'PUBLICAR', this.muro).subscribe((resultado:any) => {
      if (this.muro && typeof this.muro.totalcomentarios === 'number') {
        this.muro.totalcomentarios++;
      }
      const llamadas: any[] = [];
      for (const imagen of this.muro.imagenes) {
        // Nueva a subir
        if (imagen.url == '' && !imagen.borrada) {
          const formData = new FormData();
          formData.append('data', imagen.data);
          formData.append('principal', '');
          formData.append('tipo', this.muro.rs_tipo);
          formData.append('tipo_id', resultado.id);
          const token = localStorage.getItem('token');
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
        // Borrar foto
        } else if (imagen.borrada && imagen.url != '') {
          llamadas.push(this.query.query('muros', 'DELETE_FOTO', { ft_id: imagen.ft_id }));
        }
      }
      if (llamadas.length == 0) {
        this.actualizarMuro(resultado.id);
        return;
      }
      // Convertir array → objeto para evitar deprecación
      const llamadasObj = llamadas.reduce((acc, obs, i) => {
        acc[i] = obs;
        return acc;
      }, {} as { [key: string]: any });

      forkJoin(llamadasObj).subscribe(resultados => {        
        this.actualizarMuro(resultado.id);        
      });
    });
  }

  borrarFoto(indexABorrar: number, temporal: boolean = false) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.muro.imagenes[indexABorrar].borrada = true;
        this.muro.previewUrl[indexABorrar].borrada = true;
        /*this.muro.imagenes = this.muro.imagenes.filter(
          (_: any, index: number) => index !== indexABorrar
        );
        this.muro.previewUrl = this.muro.previewUrl.filter(
          (_: any, index: number) => index !== indexABorrar
        );*/
      } else {
      }
    });
  }

  actualizarMuro(id: number = 0) {
    this.query.query('muros', 'RED', { ID: 0, rs_id: (this.muro.rs_parent_id != 0 ? this.muro.rs_parent_id : id), tipo: this.muro.rs_tipo, tipo_id: this.muro.rs_tipo_id, rs_ma_id: this.muro.rs_ma_id, page: this.muro.page, limit: 2 }).subscribe((resultado:any) => {
      if (this.muro.nuevo) {
        this.muro = this.funciones.initMuro(this.muro as Muro);
        this.muroService.agregar(resultado[0]);
      } else if (this.muro.rs_id == 0) {
        this.muro = resultado[0];
        this.muro.showeditar = false;
        //this.muroService.agregar(this.muro);
      } else {
        this.muro = resultado[0];
        this.muro.showeditar = false;
      }
      this.muroService.actualizar(this.muro);
      this.setNumeroPublicaciones();
      this.loader.hide();
    });
  }

  onClickImagen() {
    // Simula el click en el input file
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.loader.show();

      // 👉 Punto de inicio (muy importante)
      const startIndex = this.muro.imagenes.length;

      Array.from(input.files).forEach((file: File, i: number) => {

        const index = startIndex + i;

        // Reservar posición sin pisar lo existente
        this.muro.imagenes[index] = { data: '', url: '', borrada: false, ft_id: 0 };
        this.muro.previewUrl[index] = { data: '', url: '', borrada: false, ft_id: 0 };

        // Imagen original
        const readerOriginal = new FileReader();
        readerOriginal.onload = () => {
          this.muro.imagenes[index].data = readerOriginal.result;
        };
        readerOriginal.readAsDataURL(file);

        // Preview recortado
        this.funciones.recortarImagenCuadrada(file, 500)
          .then((dataUrl) => {
            this.muro.previewUrl[index].data = dataUrl;
          })
          .catch(console.error);
      });

      this.loader.hide();
    }
  }

  borrarPublicacion() {
    if (Number(this.muro.rs_us_id) !== Number(this.misdatos?.ID)) return;
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta publicación?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('muros', 'BORRAR', { rs_id: this.muro.rs_id }).subscribe((resultado:any) => {
          // Borrar fotos
          this.query.query('muros', 'DELETE_FOTO', {rs_id: this.muro.rs_id}).subscribe((resultado:any) => {
          });
          this.muro.borrada = true;
          if (this.muro && typeof this.muro.numcomentarios === 'number') {
            this.muro.numcomentarios--;
          }
          if (this.muro && typeof this.muro.totalcomentarios === 'number') {
            this.muro.totalcomentarios++;
          }
          this.muroService.actualizar(this.muro);
          this.loader.hide();
        });
      } else {
      }
    });
  }

  comentarPublicacion() {
    // El campo de respuesta es único y permanece fijo al pie del modal.
    // La petición se propaga al contenedor de la conversación.
    this.abrirConversacion.emit();
  }

  cancelarPublicacion() {
    this.muro.showeditar = false;
    if (!this.muro || !this.muro.parent) return;

    const padre = this.muro.parent;

    // eliminar el comentario del array del padre
    padre.comentarios = padre.comentarios.filter(
      (c: any) => c !== this.muro
    );

    // volver al padre
    this.muro = padre;

    this.muroService.actualizar(this.muro);
  }

  dejarHuella() {
    this.query.query('huellas', 'HUELLA', { tipo: 'RS', tipo_id: this.muro.rs_id }).subscribe((resultado:any) => {
      this.muro.usuarioshuella = resultado.usuarioshuella;
      if (this.muro.mihuella == 0) {
        this.muro.mihuella = 1;
        ++this.muro.huellas;
      } else {
        this.muro.mihuella = 0;
        --this.muro.huellas;
      }
    });
  }

  meApunto() {
    if ((this.muro as any).paseo_finalizado) {
      Swal.fire('Paseo finalizado', 'Ya no es posible apuntarse. Puedes seguir compartiendo recuerdos.', 'info');
      return;
    }
    let text = '';
    if (this.muro.miparticipacionpaseo)
      text = '¿Ya no quieres participar en el paseo?';
    else
      text = '¿Quieres apuntarte a este paseo?';
    Swal.fire({
      title: 'Confirmación',
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.query.query('muros', 'APUNTARSE', { rs_id: this.muro.rs_id }).subscribe((resultado:any) => {
          if (resultado?.resultado !== 'OK') {
            Swal.fire('No se pudo actualizar', resultado?.mensaje || 'Comprueba si el paseo sigue disponible.', 'warning');
            return;
          }
          this.muro.miparticipacionpaseo = !this.muro.miparticipacionpaseo;
          if (this.muro.miparticipacionpaseo) {
            ++this.muro.rs_participantes_paseo;
          } else {
            --this.muro.rs_participantes_paseo;
          }
        });
      } else {
      }
    });
  }

  setNumeroPublicaciones() {
    this.query.query('muros', 'NUMERO_PUBLICACIONES', { ID: this.misdatos.ID, tipo: this.tipo, tipo_id: this.tipoId }).subscribe((resultado:any) => {
      const numeroPublicaciones = resultado.registros;
      // Asignar el número de publicaciones a cada tipo de publicación
      this.tipopublicaciones.forEach(tipo => {
        tipo.numero = numeroPublicaciones.find((item: any) => item.rs_tipo_publicacion === tipo.va_id)?.numero || 0;
      });
      this.muroFiltrosService.setValores(this.tipopublicaciones);
    });
  }

  validarFormulario(): boolean {
    if (this.muro.nivel == 0) {
      // Paseo: validar datos del paseo
      if (this.muro.rs_tipo_publicacion == '01') {
        if (!this.muro.paseo?.rsp_fecha || !this.muro.paseo?.rsp_hora || !this.muro.paseo?.rsp_ubicacion) {
          Swal.fire('Error', 'Completa los datos del paseo', 'error');
          return false;
        }
      }
      // Servicio: validar tipo de servicio
      if (this.muro.rs_tipo_publicacion == '02') {
        if (!this.muro.servicio?.rsse_tipo) {
          Swal.fire('Error', 'Selecciona un tipo de servicio', 'error');
          return false;
        } else if (!this.muro.servicio?.rsse_rol) {
          Swal.fire('Error', 'Selecciona un rol para el servicio de paseo', 'error');
          return false;
        }
      }
    }
    if (this.muro.nivel == 0 && !this.muro.rs_texto.trim()) {
      Swal.fire('Error', 'El texto de la publicación no puede estar vacío', 'error');
      return false;
    }
    return true;
  }

  async abrirModalDenuncia(): Promise<void> {
    if (!this.misdatos?.ID) {
      window.location.href = this.global.urlServer + 'login';
      return;
    }
    if (this.enviandoReporte || Number(this.muro.rs_us_id) === Number(this.misdatos.ID)) return;

    const resultado = await Swal.fire({
      title: this.muro.nivel > 0 ? 'Denunciar comentario' : 'Denunciar publicación',
      text: 'Cuéntanos qué ocurre. Revisaremos tu aviso para cuidar la comunidad.',
      icon: 'info',
      iconColor: '#527B69',
      customClass: { container: 'ig-denuncia-layer', popup: 'ig-denuncia-modal', confirmButton: 'ig-denuncia-confirmar', cancelButton: 'ig-denuncia-cancelar' },
      showCancelButton: true,
      confirmButtonText: 'Enviar denuncia',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#527B69',
      reverseButtons: true,
      focusConfirm: false,
      didOpen: (popup) => {
        // Por encima del backdrop de comentarios (z-index: 2147483000).
        // El z-index debe aplicarse al contenedor Swal, no solo al popup.
        Swal.getContainer()?.style.setProperty('z-index', '2147483200', 'important');
        // SweetAlert2 monta el diálogo en <body>; aplicamos el estilo en el propio modal
        // para no depender de la encapsulación CSS de Angular.
        const style = document.createElement('style');
        style.textContent = `
          .ig-denuncia-modal { width:min(95vw,460px); border-radius:20px; padding:24px; color:#234435; text-align:left; }
          .ig-denuncia-modal .swal2-title { color:#234435; font-weight:700; font-size:1.35rem; }
          .ig-denuncia-modal .swal2-html-container { margin:16px 0 8px; overflow:visible; }
          .ig-denuncia-modal .ig-denuncia-label { display:block; margin:15px 0 6px; text-align:left; font-weight:600; font-size:.9rem; color:#385B4B; }
          .ig-denuncia-modal .ig-denuncia-label span { font-weight:400; color:#667a6e; }
          .ig-denuncia-modal .ig-denuncia-select, .ig-denuncia-modal .ig-denuncia-textarea { display:block; box-sizing:border-box; width:100%; max-width:100%; margin:0; background:#fff; border:1px solid #d4e2d9; border-radius:11px; padding:11px 12px; color:#234435; font-size:.95rem; outline:none; }
          .ig-denuncia-modal .ig-denuncia-select:focus, .ig-denuncia-modal .ig-denuncia-textarea:focus { border-color:#527B69; box-shadow:0 0 0 3px rgba(82,123,105,.14); }
          .ig-denuncia-modal .ig-denuncia-textarea { resize:vertical; min-height:88px; }
          .ig-denuncia-modal .swal2-actions { gap:8px; justify-content:flex-end; margin-top:15px; }
          .ig-denuncia-modal .swal2-confirm, .ig-denuncia-modal .swal2-cancel { border-radius:10px; padding:10px 18px; font-weight:600; }
          @media(max-width:480px) { .ig-denuncia-modal { padding:17px; } }
        `;
        popup.prepend(style);
      },
      html: `
        <label for="ig-denuncia-motivo" class="ig-denuncia-label">Motivo de la denuncia</label>
        <select id="ig-denuncia-motivo" class="swal2-select ig-denuncia-select">
          <option value="">Selecciona un motivo</option>
          <option value="acoso">Acoso o amenazas</option>
          <option value="spam">Spam o publicidad engañosa</option>
          <option value="contenido_inapropiado">Contenido inapropiado</option>
          <option value="maltrato_animal">Maltrato animal</option>
          <option value="suplantacion">Suplantación de identidad</option>
          <option value="otros">Otro motivo</option>
        </select>
        <label for="ig-denuncia-detalle" class="ig-denuncia-label">Información adicional <span>(opcional)</span></label>
        <textarea id="ig-denuncia-detalle" class="swal2-textarea ig-denuncia-textarea"
                  rows="3" maxlength="500" placeholder="Describe brevemente lo sucedido"></textarea>
      `,
      preConfirm: () => {
        const motivo = (document.getElementById('ig-denuncia-motivo') as HTMLSelectElement | null)?.value ?? '';
        const detalle = (document.getElementById('ig-denuncia-detalle') as HTMLTextAreaElement | null)?.value.trim() ?? '';
        if (!motivo) {
          Swal.showValidationMessage('Selecciona el motivo de la denuncia.');
          return false;
        }
        return { motivo, detalle: detalle.slice(0, 500) };
      }
    });
    if (resultado.isConfirmed && resultado.value) {
      this.motivoSeleccionado = resultado.value.motivo;
      this.reporteDetalle = resultado.value.detalle;
      this.enviarReporte();
    }
  }

  enviarReporte(): void {
    if (!this.misdatos?.ID) { window.location.href = this.global.urlServer + 'login'; return; }
    if (!this.motivoSeleccionado || this.enviandoReporte || Number(this.muro.rs_us_id) === Number(this.misdatos.ID)) return;
    this.enviandoReporte = true;
    this.query.query('muros', 'DENUNCIAR', {
      rs_id: this.muro.rs_id,
      motivo: this.motivoSeleccionado,
      detalle: this.reporteDetalle.trim().slice(0, 500)
    }).subscribe({
      next: (respuesta: any) => {
        this.enviandoReporte = false;
        if (respuesta?.resultado === 'OK') {
          this.motivoSeleccionado = '';
          this.reporteDetalle = '';
          Swal.fire({ customClass: { container: 'ig-denuncia-layer' }, didOpen: () => Swal.getContainer()?.style.setProperty('z-index', '2147483200', 'important'), icon: 'success', title: 'Denuncia enviada', text: 'Gracias por ayudarnos a cuidar la comunidad.', timer: 2400, showConfirmButton: false });
        } else {
          Swal.fire({ icon: 'error', title: 'No se pudo enviar', text: respuesta?.mensaje || 'Inténtalo de nuevo.', didOpen: () => Swal.getContainer()?.style.setProperty('z-index', '2147483200', 'important') });
        }
      },
      error: () => {
        this.enviandoReporte = false;
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la denuncia.', didOpen: () => Swal.getContainer()?.style.setProperty('z-index', '2147483200', 'important') });
      }
    });
  }

  addPregunta() {
    if (!this.pregunta_encuesta.rse_pregunta?.trim() || this.pregunta_encuesta.rse_tipo == '') {
      return; // no añadir si no hay pregunta escrita
    }

    if (!this.muro.encuesta) {
      this.muro.encuesta = [];
    }

    this.pregunta_encuesta.rse_rs_id = this.muro.rs_id;
    this.pregunta_encuesta.va_nombre = this.tipoencuestas.find((item: any) => item.va_id === this.pregunta_encuesta.rse_tipo)?.va_nombre || '';

    this.muro.encuesta = [...this.muro.encuesta, this.pregunta_encuesta];

    this.pregunta_encuesta = {
      rse_id: 0,
      rse_rs_id: this.muro.rs_id,
      rse_pregunta: '',
      rse_tipo: '',
      rse_respuesta_1: '',
      rse_respuesta_2: '',
      rse_respuesta_3: '',
      rse_respuesta_4: '',
      va_nombre: '',
      rser_respuesta: '',
      rse_borrado: false,
      respuestas: null,
      totalVotos: 0,
      busy: false,
    };
  }

  getRespuesta(i: number): string {
    return (this.pregunta_encuesta as any)[`rse_respuesta_${i}`] ?? '';
  }

  setRespuesta(i: number, value: string): void {
    (this.pregunta_encuesta as any)[`rse_respuesta_${i}`] = value;
  }

}
